// Types
import { ActionCreator } from 'redux';
import { ThunkAction } from 'redux-thunk';
import Handsontable from 'handsontable';
import {
    HotTableStoreActions,
    HotTableStoreState,
    SetActiveTableAction,
    TableInstanceObject,
} from './hotTableStoreTypes';

// Selectors
import { getActiveTable } from './hotTableSelectors';

export const setActiveTable: ActionCreator<SetActiveTableAction, [Handsontable | null]> = (activeTable) => ({
    type: 'SET_ACTIVE_TABLE',
    activeTable,
});

export const getActiveTableThunk =
    (): ThunkAction<TableInstanceObject | null, HotTableStoreState, {}, HotTableStoreActions> =>
    (_, getHotTableState) =>
        getActiveTable(getHotTableState());
